const categorySelection = document.getElementById('categorySelection');
const dailyWinnersView = document.getElementById('dailyWinnersView');
const principalWinnersView = document.getElementById('principalWinnersView');

const btnDaily = document.getElementById('btnDaily');
const btnPrincipal = document.getElementById('btnPrincipal');

const btnBackDaily = document.getElementById('btnBackDaily');
const btnBackPrincipal = document.getElementById('btnBackPrincipal');

const searchDailyWinners = document.getElementById('searchDailyWinners') as HTMLInputElement | null;

if (btnDaily && categorySelection && dailyWinnersView) {
    btnDaily.addEventListener('click', () => {
        categorySelection.classList.add('hidden');
        dailyWinnersView.classList.remove('hidden');
    });
}

if (btnPrincipal && categorySelection && principalWinnersView) {
    btnPrincipal.addEventListener('click', () => {
        categorySelection.classList.add('hidden');
        principalWinnersView.classList.remove('hidden');
    });
}

if (btnBackDaily && categorySelection && dailyWinnersView) {
    btnBackDaily.addEventListener('click', () => {
        dailyWinnersView.classList.add('hidden');
        categorySelection.classList.remove('hidden');
        if (searchDailyWinners) {
            searchDailyWinners.value = '';
            searchDailyWinners.dispatchEvent(new Event('input'));
        }
    });
}

if (btnBackPrincipal && categorySelection && principalWinnersView) {
    btnBackPrincipal.addEventListener('click', () => {
        principalWinnersView.classList.add('hidden');
        categorySelection.classList.remove('hidden');
    });
}

if (searchDailyWinners) {
    searchDailyWinners.addEventListener('input', (e: Event) => {
        const target = e.target as HTMLInputElement;
        const query = target.value.toLowerCase().trim();
        const rows = document.querySelectorAll('#dailyWinnersList .winner-row');

        rows.forEach(row => {
            const name = row.getAttribute('data-name') || '';
            if (query === '' || name.includes(query)) {
                (row as HTMLElement).style.display = 'flex';
            } else {
                (row as HTMLElement).style.display = 'none';
            }
        });
    });
}
